import Header from 'components/headers/bulletins'
import EditUserIcon from 'assets/images/settingFund/edit-user.svg'
import InfiniteScroll from 'react-infinite-scroll-component'
import { useCallback, useState } from 'react'
import { useParams } from 'react-router-dom'
import useGetUsers from 'modules/fund/tabs/hooks/useGetUsers'
import DotsLoading from 'components/loadings/dotsLoading'
import Item from './item'
import EditUserInformationModal from 'components/modals/EditUserInformation'
import ChangeShareModal from 'components/modals/changeShare'
import ChangeToManagerModal from 'components/modals/changeToManager'
import UserGuarantorModal from 'components/modals/UserGuarantor'
import DetactivateModal from 'components/modals/deactivate'
import ActivateModal from 'components/modals/activate'
import ChangeToNormalModal from 'components/modals/changeToNormal'

export default function UsersInformation() {
    const [isOpen, setIsOpen] = useState<boolean>(false)
    const [isOpenShareModal, setIsOpenShareModal] = useState<boolean>(false)
    const [isOpenGuarantorModal, setIsOpenGuarantorModal] =
        useState<boolean>(false)
    const [isOpenChangeToManagerModal, setIsOpenChangeToManagerModal] =
        useState<boolean>(false)
    const [selectedUser, setSelectedUser] = useState<
        IMoneyPoolResults | undefined
    >()
    const [isChangeToNormalModal, setIsChangeNormalModla] =
        useState<boolean>(false)
    const [isOpenDeactivateModal, setIsOpenDeactivateModal] =
        useState<boolean>(false)
    const [isActivateModal, setIsActivateModal] = useState<boolean>(false)
    const { id } = useParams()
    const {
        data,
        isLoading,
        poolShipId,
        fetchNextPage,
        numberOfShares,
        refetch,
    } = useGetUsers(id)
    const onWatchEnd = useCallback(() => {
        fetchNextPage()
    }, [fetchNextPage])
    return (
        <div>
            <Header title="تنظیمات صندوق" />
            <div className=" flex my-3">
                <img src={EditUserIcon} alt="users" className=" mx-2" />
                <p>ویرایش اطلاعات اعضا</p>
            </div>
            <hr />
            <div className=" px-2">
                <InfiniteScroll
                    next={onWatchEnd}
                    hasMore={
                        data
                            ? data?.pages[data.pages.length - 1].next
                                ? true
                                : false
                            : false
                    }
                    dataLength={
                        data ? data.pages.flatMap((x) => x.results).length : 0
                    }
                    loader={<DotsLoading />}
                >
                    <div>
                        {data && !isLoading ? (
                            <>
                                {data.pages
                                    .flatMap((x) => x.results)
                                    .map((item) => (
                                        <div key={item.id}>
                                            <Item
                                                key={item.id}
                                                item={item}
                                                setIsOpen={setIsOpen}
                                                setSelectedUser={
                                                    setSelectedUser
                                                }
                                            />
                                        </div>
                                    ))}
                            </>
                        ) : (
                            <DotsLoading />
                        )}
                    </div>
                </InfiniteScroll>
            </div>
            <EditUserInformationModal
                show={isOpen}
                onHide={() => setIsOpen(false)}
                user={selectedUser}
                setIsOpenShareModal={setIsOpenShareModal}
                setIsOpenChangeToManagerModal={setIsOpenChangeToManagerModal}
                setIsOpenGuarantorModal={setIsOpenGuarantorModal}
                setIsOpenDeactivateModal={setIsOpenDeactivateModal}
                setIsChangeNormalModla={setIsChangeNormalModla}
                setIsActivateModal={setIsActivateModal}
            />
            <ChangeShareModal
                show={isOpenShareModal}
                onHide={() => setIsOpenShareModal(false)}
                user={selectedUser}
                refetch={refetch}
            />
            <ChangeToManagerModal
                show={isOpenChangeToManagerModal}
                onHide={() => setIsOpenChangeToManagerModal(false)}
                user={selectedUser}
                refetch={refetch}
            />
            <UserGuarantorModal
                show={isOpenGuarantorModal}
                onHide={() => setIsOpenGuarantorModal(false)}
                users={data}
                onWatchEnd={onWatchEnd}
                refetch={refetch}
                selectedUser={selectedUser}
            />
            <DetactivateModal
                show={isOpenDeactivateModal}
                onHide={() => setIsOpenDeactivateModal(false)}
                user={selectedUser}
                refetch={refetch}
            />
            <ActivateModal
                show={isActivateModal}
                onHide={() => setIsActivateModal(false)}
                user={selectedUser}
                refetch={refetch}
            />
            <ChangeToNormalModal
                show={isChangeToNormalModal}
                onHide={() => setIsChangeNormalModla(false)}
                user={selectedUser}
                refetch={refetch}
            />
        </div>
    )
}
